import React from 'react';
import { observer } from 'mobx-react-lite';

import { CandidateCard } from './candidate-card';
import { sortingFunction } from '../../../assets/enums/assetType.enum';

import type { Candidate } from '../../../app/entities/candidate';

import styles from './candidates-list.module.scss';
type CandidatesListProps = {
  candidates: Candidate[];
  castId?: string;
  sortBy: string;
};

export const CandidatesList: React.FC<CandidatesListProps> = observer(
  ({ candidates, castId, sortBy }) => {
    if (!candidates?.length) {
      return (
        <div className={styles['empty-results-container']}>
          <p>No results found</p>
        </div>
      );
    }

    const sortedCandidates = candidates
      ?.slice()
      // @ts-ignore
      .sort(sortingFunction[sortBy])
      .sort((candidate) => (candidate._id === castId ? -1 : 1));

    return (
      <div className={styles['container']}>
        {sortedCandidates?.map((candidate) => (
          <CandidateCard
            key={candidate._id}
            candidate={candidate}
            isSelectedCandidate={candidate._id === castId}
          />
        ))}
      </div>
    );
  },
);
